module.exports = __webpack_public_path__ + "img/qy_26.b1297477.png";